<template>
  <div class="configBar">
    <v-sheet class="configBar_main">
      <div class="configBar_title">
        <div class="configBar_title_text">設定</div>
      </div>
      <div class="configBar_events_container scrollParent">
        <div class="configBar_events scrollChild">
          <config-bar-link
            v-for="(setting, i) in settings"
            :key="`settings-link-${i}`"
            :setting="setting"
            :active="setting.key === activeSetting"
            :is-admin="isAdmin"
          />
          <v-divider class="configBar_divider" />
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import ConfigBarLink from '@/components/settings/ConfigBarLink.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ConfigBar',
  components: {
    ConfigBarLink,
  },
  computed: {
    ...mapGetters('common', {
      updateVersionExists: 'updateVersionExists',
    }),
    ...mapState({
      currentCameraPolicy: (state) => state.common.currentCameraPolicy,
      isCurrentAvatarOwner: (state) => state.settings.isCurrentAvatarOwner,
    }),
    isAdmin() {
      return this.isCurrentAvatarOwner;
    },
    activeSetting() {
      return this.$route.params.parent;
    },
    settings() {
      // Conditions for owner, access, liveOnly
      const haveOwnerAccessLiveOnlyCondition =
        this.isCurrentAvatarOwner ||
        (!this.currentCameraPolicy.access &&
          !this.currentCameraPolicy.liveOnly);
      // const haveOwnerLiveOnlyCondition =
      //   this.isCurrentAvatarOwner || !this.currentCameraPolicy.liveOnly;

      // Map setting items
      const items = [
        {
          title: '組織の切り替え',
          desc: 'ログインしている組織の切り替え',
          to: { name: 'settings-account-org' },
        },
      ];
      if (haveOwnerAccessLiveOnlyCondition) {
        items.push(
          {
            title: 'カメラグループ一覧',
            desc: '登録したカメラを、グループに分けて設定',
            to: { name: 'settings-cams' },
          },
          {
            title: 'ユーザー一覧',
            desc: 'ユーザーの新規登録、確認、削除、登録情報の変更',
            to: {
              name: 'settings-users',
            },
          }
        );
      }
      items.push({
        title: 'カメラ一覧',
        desc: 'カメラ情報の確認、カメラ名の変更、ファームウェア更新',
        icon: this.updateVersionExists,
        to: { name: 'settings-firmware' },
      });
      // if (haveOwnerLiveOnlyCondition) {
      //   items.push({
      //     title: '録画映像のダウンロード',
      //     desc: 'クラウドに保存している録画映像のダウンロード',
      //     to: { name: 'settings-record' },
      //   });
      // }
      if (haveOwnerAccessLiveOnlyCondition) {
        items.push(
          {
            title: '履歴一覧',
            desc: 'アプリ操作履歴、イベント履歴、システム履歴の一覧',
            to: {
              name: 'settings-history',
              params: {
                child: 'operation',
              },
            },
          },
          {
            title: '通知機能の設定',
            desc: '通知方法、対象のカメラグループの設定',
            to: {
              name: 'settings-notice',
            },
          }
        );
      }
      return items;
    },
  },
};
</script>

<style lang="scss">
.configBar {
  &_notification {
    &.v-sheet.theme--light {
      .configBar & {
        flex-grow: 0;
        margin-bottom: 30px;
        color: #fff;
        background-color: var(--primary-color);
        padding-bottom: 16px;
        box-shadow: 0 3px 12px 0 rgba(0, 45, 170, 0.19);
      }
    }
    &_supTitle {
      font-size: 14px;
      font-weight: 600;
      line-height: 17px;
      margin-bottom: 7px;
    }
    &_title {
      font-size: 16px;
      font-weight: 600;
      line-height: 21px;
      margin-bottom: 2px;
    }
    .eventItem {
      border-top: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .eventItem_time {
      color: #fff;
    }
    .eventItem_date {
      font-weight: 400;
    }
    .eventItem_hour {
      font-weight: 400;
    }
    .eventItem_chevron {
      display: none;
    }
  }
  &_main {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
  &.v-sheet {
    padding-right: 22px;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 17px;
    padding-right: 8px;
    &_text {
      font-size: 14px;
      font-weight: 600;
      color: var(--text-color);
    }
    &_btn {
      .icon {
        margin-left: 8px;
        margin-right: -5px;
        position: relative;
      }
    }
    &_icon {
      &-open {
        transform: rotate(180deg);
      }
    }
  }
  &_divider {
    border-color: #ccc;
  }
  &_events {
    padding-right: 8px;
    &_container {
      &:before {
        content: '';
        position: absolute;
        top: 0;
        right: 8px;
        left: 0;
        height: 1px;
        background: #ccc;
        z-index: 3;
      }
    }
    .cofigBar {
      &Link {
        padding: 10px;
        &_desc {
          margin: 3px 0 0;
        }
      }
    }
  }
}
</style>
